import React, { useEffect } from 'react';
import { GameStructure, GameSection, loadingStore, useSoundWatcher } from '@pascal/pascal-core';
import { PayoutsAndResultsContainer } from './payoutsAndResultsContainer';
import { FooterWr } from './footer';
import { HeaderWr } from './header';
import GameMain from '../game/main';
import { observer } from 'mobx-react-lite';
import { applicationStore, gameConfigStore, lobbyStore } from '@pascal/pascal-core/shared/core/store';
import gameLogo from '../assets/images/roulette-logo.png';
import { toUpperCase } from '../helpers/toUpperCase';
import useSoundsByName from '../hooks/useSoundsByName';

export const WebGame = observer(({ isReplay }) => {
  const { isSkipLobby } = gameConfigStore;
  const { setIsDemo } = applicationStore;
  const { roomName } = lobbyStore;

  const {
    limits: { maxBet },
  } = gameConfigStore;

  useEffect(() => {
    return () => {
      setIsDemo(false);
      loadingStore.updateLoading({ isGameInitialLoaded: false });
    };
  }, []);

  const soundsByName = useSoundsByName();
  useSoundWatcher(toUpperCase(roomName), soundsByName);

  return (
    <GameStructure hasLobby={isSkipLobby} lobbyLogoImageSrc={gameLogo} hasGameTypeLoading>
      {!isReplay && <HeaderWr />}
      <GameSection haveNotification>
        {!isReplay && <PayoutsAndResultsContainer />}
        <GameMain isReplay={isReplay} />
      </GameSection>
      {!isReplay && <FooterWr />}
      {/* <RightContainer /> */}
    </GameStructure>
  );
});
